import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f3a0482"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "offer-item" }
const _hoisted_2 = { class: "offer-grid" }
const _hoisted_3 = { class: "image-col" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "details-col" }
const _hoisted_6 = { class: "center-items" }
const _hoisted_7 = { class: "artist-name" }
const _hoisted_8 = { class: "artwork-name" }
const _hoisted_9 = {
  key: 0,
  class: "offer-price"
}
const _hoisted_10 = { class: "status-col" }
const _hoisted_11 = { class: "center-items" }
const _hoisted_12 = { class: "actions-col" }
const _hoisted_13 = { class: "center-items" }
const _hoisted_14 = { class: "actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "image",
          src: _ctx.imageSrc
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.artistName), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.artworkTitle), 1),
          (_ctx.priceText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.priceText), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.statusParsed), 1)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            (_ctx.isPending)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  icon: "",
                  variant: "text",
                  disabled: _ctx.disabled,
                  title: "Approve",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('approve', _ctx.offer.id)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { icon: "mdi-check" })
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.isPending)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  icon: "",
                  variant: "text",
                  disabled: _ctx.disabled,
                  title: "Decline",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('decline', _ctx.offer.id)))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { icon: "mdi-close" })
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_v_divider, { class: "separator" })
  ]))
}